export const VIBE_EVAL_COMMAND_MESSAGE = 'Test this agentic flow by running an evaluation.'

export const toTestId = (value: string): string => value.toLowerCase().replace(/\s+/g, '-')
